import {Component, OnInit} from '@angular/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

@Component({
    selector: 'app-epc',
    templateUrl: './epc.component.html',
    styleUrls: ['./epc.component.scss']
})
export class EpcComponent implements OnInit {
    activeItemIndex = 0;

    items = [
        {
            title: 'Projekty',
            icon: 'fa-settings',
            href: 'projects'
        }
    ];

    constructor() {
        console.log(window.location.hash)
        if (window.location.hash) {
            this.navigateByHash(window.location.hash);
        } else {
            this.onChangeTab(0);
        }
    }

    ngOnInit(): void {

    }

    navigateByHash(hash) {
        this.activeItemIndex = this.items.findIndex(item => item.href === hash.split('#')[2]);
        console.log(this.activeItemIndex)
        if (isNullOrUndefined(this.activeItemIndex) || this.activeItemIndex < 0) {
            this.onChangeTab(0);
        }
    }

    onChangeTab(index) {
        this.activeItemIndex = index;
        location.hash = `/epc#${this.items[this.activeItemIndex].href}`;
    }
}
